import { Review } from './reports';

export interface DeelnemerIndex {
  id?: number;
  uoNummer?: number;
  bedrijfsNaam?: string;
  vestigingsStraat?: string;
  vestigingsNummer?: string;
  vestigingsNummerToevoeging?: string;
  vestigingsPlaats?: string;
}

interface DeskundigeIndex {
  bedrijfsNaam?: string;
}

export enum RapportageStatus {
  Definitief = 0,
  ConceptHerberekening = 1,
}

export interface TeeltplanIndex {
  id: number;
  deelnemer: DeelnemerIndex;
  deskundige: DeskundigeIndex;
  review: Review;
  registratieJaar: number;
  dienstverlenerNaam?: string;
  rapportageStatus: RapportageStatus;
}
